export default {
  env: 'pre-prod',
  kibanaApi: 'https://api-support-preprod.xfinity.com/logger/',
};
